<template>
  <main class="md:px-44 px-7">
    <section class="grid pt-9 pb-4 gap-16 content-start items-start w-full">
      <article class="grid gap-4 md:w-80 md:mx-auto justify-center">
          <div class="h-64 w-64 justify-self-center">
            <Vue3Lottie ref="lottie" :animationData="CongratulationsGpayAnimation" :speed="1" :loop="true" />
          </div>
          <div class="grid gap-5 text-center">
            <p class="text-3xl font-blogger font-bold text-headingColor">Thank you</p>
              <span class="grid">
                <p class="text-center text-headingColor font-myriad text-base width17rem">Your DigiLocker verification has been completed!</p>
              </span>
          </div>
      </article>
    </section>
    <span class="grid pb-24"></span>
    <section>
    </section>
    <over-lay-go-back :starterOverLay="isOverLay" @on-click-back-prev="handleBackToPrev"/>
  </main>
</template>
<script>
import overLayGoBack from '../components/overLayGoBack.vue';
import CongratulationsGpayAnimation from '../assets/animation/Congratulations-Gpay-Animation.json';

export default {
  name: 'KycSuccess',
  mounted() {
    this.init();
  },
  components: { overLayGoBack },
  data() {
    return {
      isOverLay: undefined,
      CongratulationsGpayAnimation,
      // timerInterval: undefined,
      // timer: 3,
    };
  },
  methods: {
    init() {
      setTimeout(() => {
        this.isOverLay = true;
      }, 4000);
      // this.timerInterval = setInterval(() => {
      //   if (this.timer > 1) {
      //     this.timer -= 1;
      //   } else {
      //     // this.$router.push({ name: 'Personal Profile Step 2' });
      //     clearInterval(this.timerInterval);
      //   }
      // }, 1000);
    },
    handleBackToPrev() {
      this.isOverLay = false;
      setTimeout(() => {
        this.isOverLay = true;
      }, 4000);
    }
  },
  // beforeUnmount() {
  //   clearInterval(this.timer);
  // },
};
</script>
<style lang="scss" scoped>
.width17rem{
  width: 17rem;
}
</style>
